import React, { useState } from 'react';
import { apiFetch } from 'utils';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import { duckify } from '../../utils/duckify';
import { flashMessages } from '../../ducks';

const SsoAuthenticationLink = ({ buttonText, className, disabled, getAuthToken, flash }) => {
  const [jumping, setJumping] = useState(false);
  const ssoLogin = (token, ssoUrl, redirectUrl) => {
    const f = document.createElement('form');
    f.setAttribute('method', 'post');
    f.setAttribute('class', 'hidden');
    f.setAttribute('action', ssoUrl);

    const i = document.createElement('input');
    i.setAttribute('type', 'password');
    i.setAttribute('name', 'access-token');
    i.setAttribute('value', token);
    f.appendChild(i);

    const ro = document.createElement('input');
    ro.setAttribute('type', 'url');
    ro.setAttribute('name', 'redirect-url');
    ro.setAttribute('value', redirectUrl);
    f.appendChild(ro);

    document.body.appendChild(f);
    f.submit();
  };

  const jumpToSchool = () => {
    setJumping(true);
    getAuthToken().then(({ token, sso_url, redirect_url }) => {
      ssoLogin(token, sso_url, redirect_url);
    }).catch(response => {
      flash({ message: 'Submit failed', type: 'danger' });
      setJumping(false);
    });
  };

  return (
    <button type='button' className={className} onClick={jumpToSchool} disabled={disabled || jumping}>
      {jumping ? <FontAwesome name='spinner' spin /> : buttonText}
    </button>
  );
};
SsoAuthenticationLink.propTypes = {
  buttonText: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool
};
SsoAuthenticationLink.defaultProps = {
  className: '',
  disabled: false
};

const mapDispatchToProps = (dispatch, { schoolId, studentId }) => ({
  getAuthToken: () => dispatch(
    (dispatch, getState) => {
      const path = studentId ? 'sso_jwt/generate_application_auth' : 'sso_jwt/generate_school_auth';
      return apiFetch.post(getState(), path, {
        school_id: schoolId,
        student_id: studentId,
        redirect_url: window.location.origin
      });
    }
  ),
  flash: (props) => dispatch(flashMessages.actions.show(props))
});
export default duckify(() => ({}), () => ({}), mapDispatchToProps)(SsoAuthenticationLink);
